import { MEP_OVERVIEW_ROUTE } from '~/contants/mep'

// A participant fills a Befindlichkeitsblatt from the trainer's link without a login.
const excludedAuthPaths = ['/login', '/logout', '/otp/login', '/otp/redirect', '/wellbeing-sheet/']

// An MEP partner user only ever works with their own courses, so the rest of
// the trainer portal is redirected away instead of just hidden in the menu.
function isMepRoute(path: string) {
  return path === '/dashboard' || path.startsWith('/mep')
}

export default defineNuxtRouteMiddleware((_to: any, _from: any) => {
  const userStore = useUserStore()
  const isPublicPath = excludedAuthPaths.some((path) => _to.path.includes(path))

  if (!userStore.isLoggedInAsContact) {
    if (!isPublicPath) return navigateTo('/login')
    return
  }

  if (userStore.isMepPartner && !isPublicPath && !isMepRoute(_to.path)) {
    return navigateTo(MEP_OVERVIEW_ROUTE)
  }
})
